"use strict";
exports.__esModule = true;
exports.findInObject = exports.useFindIn = exports.findIn = void 0;
/**
 * Created by rouven on 11.04.17.
 */
var react_1 = require("react");
var findIn = function (object) { return function (key) {
    if (object == null || key == null) {
        return undefined;
    }
    var keyParts = key.split('.');
    if (keyParts.length > 1) {
        var newObject = object[keyParts.shift()];
        return (0, exports.findIn)(newObject)(keyParts.join('.'));
    }
    return (object && typeof object === 'object' && key in object && typeof object[key] !== 'undefined')
        ? object[key]
        : undefined;
}; };
exports.findIn = findIn;
var useFindIn = function (object) { return (0, react_1.useCallback)((0, exports.findIn)(object), [object]); };
exports.useFindIn = useFindIn;
/**
 * Finds objects in given object, that are indexed with the key or parts of the key
 *
 * @param key - key words to search for. words are seperated with '.'
 * @param object - object to be searched. is indexable via key: string
 * @returns object, if object is found or null if no object is found
 */
var findInObject = function (key, object) {
    var result = (0, exports.findIn)(object)(key);
    return result === undefined ? null : result;
};
exports.findInObject = findInObject;
exports["default"] = exports.findInObject;
